module.exports = "<svg width=\"10\" height=\"12\" viewBox=\"0 0 16 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.5638 7.64045H13.6895V5.86247C13.6895 2.62989 11.1372 0 8 0C4.86277 0 2.31045 2.62989 2.31045 5.86247V7.64045H0.436181C0.195409 7.64045 0 7.8418 0 8.08989V19.5506C0 19.7987 0.195409 20 0.436181 20H15.5638C15.8046 20 16 19.7987 16 19.5506V8.08989C16 7.8418 15.8046 7.64045 15.5638 7.64045ZM4.70945 7.64045V5.86247C4.70945 3.99303 6.1857 2.47191 8 2.47191C9.81408 2.47191 11.2906 3.99303 11.2906 5.86247V7.64045H4.70945Z\" fill=\"#F45353\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/lock-close.svg
// module id = 96
// module chunks = 0